<template>
    <div>
        <OutcomeReportComponent />
    </div>
</template>
  
<script>

import OutcomeReportComponent from "@/components/ReportComponents/OutcomesReport.vue";

export default {
    name: "report-view",
    components: { OutcomeReportComponent },
    title: 'Report',
}
</script>
  